import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, Validators } from '@angular/forms';
import { FormTools } from "src/shared/util/FormTools";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AditionalMechanicsToUse, AditionalMechanicsToUseLabel, AditionalMechanicsType, AditionalMechanicsTypeLabel, Class2TypeOptionLabel, Class2TypeOptions, Class3TypeOptionLabel, Class3TypeOptions, ClassType, ClassTypeLabel, CrossedElasticsType, CrossedElasticsTypeLabel, CrossedElasticsTypeNew, CrossedElasticsTypeNewLabel, ManufacturingType, ManufacturingTypeLabel, VerticalOverbiteType, VerticalOverbiteTypeLabel } from "src/app-client/_appCommon/base/AppInterfaceAndBaseClasses";
import { AppEventNames } from "src/app-client/_appCommon/base/Constants";
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { SetupDataService } from 'src/app-client/_dataservices/SetupDataService';

@Component({
  selector: 'app-client-sixth-step',
  templateUrl: './sixth-step.component.html',
  styleUrls: ['../crud-prescription.component.css'],
  providers: [PrescriptionDataService]
})
export class SixthStepComponent extends FormTools implements OnChanges
{
  public prescriptionNumber = 6;
  public isCaseDetail: boolean;
  public formAditionalMechanicsToUseHasError: boolean = false;
  public formAditionalMechanicsHasError: boolean = true;
  private unsubscribe: Subject<void> = new Subject();
  public formStep6Valid:boolean = true;
  public aditionalMechanicsTypeOptions = [
    { value: AditionalMechanicsType.ElasticsType2, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.ElasticsType2), checked: false, controlName: 'elasticType2' },
    { value: AditionalMechanicsType.ElasticsType3, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.ElasticsType3), checked: false, controlName: 'elasticType3' },
    { value: AditionalMechanicsType.CrossedElastics, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.CrossedElastics), checked: false, controlName: 'crossedElasticType' },
    { value: AditionalMechanicsType.UpperDistalization, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.UpperDistalization), checked: false, controlName: 'upperDistalizationType' },
    { value: AditionalMechanicsType.LowerDistalization, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.LowerDistalization), checked: false, controlName: 'lowerDistalizationType' },
    { value: AditionalMechanicsType.UpperMesialization, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.UpperMesialization), checked: false, controlName: 'upperMesializationType' },
    { value: AditionalMechanicsType.LowerMesialization, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.LowerMesialization), checked: false, controlName: 'lowerMesializationType' },
    { value: AditionalMechanicsType.SurgicalTreatment, display: AditionalMechanicsTypeLabel.get(AditionalMechanicsType.SurgicalTreatment), checked: false, controlName: '' }
  ];

  public aditionalMechanicsToUseOptions = [
    { value: AditionalMechanicsToUse.SkeletalAnchor, display: AditionalMechanicsToUseLabel.get(AditionalMechanicsToUse.SkeletalAnchor), checked: false, controlName: '' },
    { value: AditionalMechanicsToUse.BiteStops, display: AditionalMechanicsToUseLabel.get(AditionalMechanicsToUse.BiteStops), checked: false, controlName: '' },
    { value: AditionalMechanicsToUse.BuildUps, display: AditionalMechanicsToUseLabel.get(AditionalMechanicsToUse.BuildUps), checked: false, controlName: '' },
    { value: AditionalMechanicsToUse.PowerArms, display: AditionalMechanicsToUseLabel.get(AditionalMechanicsToUse.PowerArms), checked: false, controlName: '' },
    { value: AditionalMechanicsToUse.LingualSpikes, display: AditionalMechanicsToUseLabel.get(AditionalMechanicsToUse.LingualSpikes), checked: false, controlName: '' },
    { value: AditionalMechanicsToUse.PalatineSpikes, display: AditionalMechanicsToUseLabel.get(AditionalMechanicsToUse.PalatineSpikes), checked: false, controlName: '' },
  ];

  public verticalOverbiteTypeOptions = [
    { value: VerticalOverbiteType.Keep, display: VerticalOverbiteTypeLabel.get(VerticalOverbiteType.Keep) },
    { value: VerticalOverbiteType.Ideal, display: VerticalOverbiteTypeLabel.get(VerticalOverbiteType.Ideal) },
    { value: VerticalOverbiteType.ConcludeIn, display: VerticalOverbiteTypeLabel.get(VerticalOverbiteType.ConcludeIn) },
  ];

  public classTypeCustomOptions = [
    { value: ClassType.ClassTwo, display: ClassTypeLabel.get(ClassType.ClassTwo) },
    { value: ClassType.ClassThree, display: `Elásticos ${ClassTypeLabel.get(ClassType.ClassThree)}` },
  ];

  public class2TypeCustomOptions = [
    {
      "key": "Superior",
      "name": "Superiores",
      "values": [
        { value: Class2TypeOptions.SuperiorCanineTrimming, display: Class2TypeOptionLabel.get(Class2TypeOptions.SuperiorCanineTrimming) },
        { value: Class2TypeOptions.SuperiorPreMolarTrimming, display: Class2TypeOptionLabel.get(Class2TypeOptions.SuperiorPreMolarTrimming) },
      ]
    },
    {
      "key": "Inferior",
      "name": "Inferiores",
      "values": [
        { value: Class2TypeOptions.InferiorMolarTrimming, display: Class2TypeOptionLabel.get(Class2TypeOptions.InferiorMolarTrimming) }
      ]
    }
    
    
  ];

  public class3TypeCustomOptions = [
    {
      "key": "Superior",
      "name": "Superiores",
      "values": [
        { value: Class3TypeOptions.SuperiorMolarTrimming, display: Class3TypeOptionLabel.get(Class3TypeOptions.SuperiorMolarTrimming) },
      ]
    },
    {
      "key": "Inferior",
      "name": "Inferiores",
      "values": [
        { value: Class3TypeOptions.CanineTrimming, display: Class3TypeOptionLabel.get(Class3TypeOptions.CanineTrimming) },
        { value: Class3TypeOptions.PreMolarTrimming, display: Class3TypeOptionLabel.get(Class3TypeOptions.PreMolarTrimming) }
        
      ]
    }
    
   
  ];

  public manufacturingTypeOptions = [
    { value: ManufacturingType.Group, display: ManufacturingTypeLabel.get(ManufacturingType.Group) },
    { value: ManufacturingType.Sequential, display: ManufacturingTypeLabel.get(ManufacturingType.Sequential) },
  ];

  public CrossedElasticsTypeOptions = [
    { value: CrossedElasticsType.BothSides, display: CrossedElasticsTypeLabel.get(CrossedElasticsType.BothSides) },
    { value: CrossedElasticsType.RightSideOnly, display: CrossedElasticsTypeLabel.get(CrossedElasticsType.RightSideOnly) },
    { value: CrossedElasticsType.LeftSideOnly, display: CrossedElasticsTypeLabel.get(CrossedElasticsType.LeftSideOnly) },
  ];

  public CrossedElasticsTypeNewOptions = [
    {
      "key": "Superior",
      "name": "Superiores",
      "values": [
        { value: CrossedElasticsTypeNew.MolarTrimming, display: CrossedElasticsTypeNewLabel.get(CrossedElasticsTypeNew.MolarTrimming) }
      ]
    },
    {
      "key": "Inferior",
      "name": "Inferior",
      "values": [
        { value: CrossedElasticsTypeNew.MolarTrimming, display: CrossedElasticsTypeNewLabel.get(CrossedElasticsTypeNew.MolarTrimming) }
      ]
    },
  ];

  @Input('prescriptionData') public prescriptionData! : any;

  constructor(formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private prescriptionDataService: PrescriptionDataService,private setupDataService:SetupDataService)
  {
    super(10, formBuilder);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['prescriptionData'] != undefined && changes['prescriptionData'].currentValue !=  undefined){
      this.stepFormGroup?.controls['aditionalMechanics'].setValue(changes['prescriptionData'].currentValue.aditionalMechanics);
      this.stepFormGroup?.controls['aditionalMechanicsToUse'].setValue(changes['prescriptionData'].currentValue.aditionalMechanicsToUse);
      this.stepFormGroup?.controls['elasticType'].setValue(changes['prescriptionData'].currentValue.elasticType);
      this.stepFormGroup?.controls['elasticType2Inferior'].setValue(changes['prescriptionData'].currentValue.elasticType2Inferior);
      this.stepFormGroup?.controls['elasticType2Superior'].setValue(changes['prescriptionData'].currentValue.elasticType2Superior);
      this.stepFormGroup?.controls['elasticType3Inferior'].setValue(changes['prescriptionData'].currentValue.elasticType3Inferior);
      this.stepFormGroup?.controls['elasticType3Superior'].setValue(changes['prescriptionData'].currentValue.elasticType3Superior);
      this.stepFormGroup?.controls['crossedElasticType'].setValue(changes['prescriptionData'].currentValue.crossedElasticType);
      this.stepFormGroup?.controls['crossedElasticTypeSuperior'].setValue(changes['prescriptionData'].currentValue.crossedElasticTypeSuperior);
      this.stepFormGroup?.controls['crossedElasticTypeInferior'].setValue(changes['prescriptionData'].currentValue.crossedElasticTypeInferior);
      this.stepFormGroup?.controls['upperDistalizationType'].setValue(changes['prescriptionData'].currentValue.upperDistalizationType);
      this.stepFormGroup?.controls['lowerDistalizationType'].setValue(changes['prescriptionData'].currentValue.lowerDistalizationType);
      this.stepFormGroup?.controls['upperMesializationType'].setValue(changes['prescriptionData'].currentValue.upperMesializationType);
      this.stepFormGroup?.controls['lowerMesializationType'].setValue(changes['prescriptionData'].currentValue.lowerMesializationType);
      this.stepFormGroup?.controls['verticalOverbiteType'].setValue(changes['prescriptionData'].currentValue.verticalOverbiteType);
      this.stepFormGroup?.controls['verticalOverbiteQuantity'].setValue(changes['prescriptionData'].currentValue.verticalOverbiteQuantity);
      this.stepFormGroup?.controls['aditionalMechanicsValuesComments'].setValue(changes['prescriptionData'].currentValue.aditionalMechanicsValuesComments);
    
      changes['prescriptionData'].currentValue.aditionalMechanics.forEach(e => {
        this.aditionalMechanicsTypeOptions.find(a=> a.value == +e).checked = true;
      });

      changes['prescriptionData'].currentValue.aditionalMechanicsToUse.forEach(e => {
        if(e != "-1")
        {
          this.aditionalMechanicsToUseOptions.find(a=> a.value == +e).checked = true;
        }
        
      });

      this.selectAllAditionalMechanicsToUseOptions();
      if (this.stepFormGroup.controls['aditionalMechanics'].value.length == 0) 
      {
        this.formAditionalMechanicsHasError = true;
      }
      else 
      {
        this.formAditionalMechanicsHasError = false;
      }


      
    } 
  }

  ngOnInit(): void
  {
    this.activatedRoute.url.subscribe( url =>
    {
      this.isCaseDetail = url.toString().contains('detail');
    });

    BroadcastManager.Instance.on(AppEventNames.onUpdatePrescriptionStepByNumber)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        let number = e[0];

        if (number && this.prescriptionNumber == number)
          this.updateStepPrescription();
      });

      BroadcastManager.Instance.on("step6Valid")
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([data]: any) =>
      {
        this.formStep6Valid = data[0];
      });

    this.stepFormGroup = this.formBuilder.group({
      id: [0, null],
      aditionalMechanics: [[], null],
      aditionalMechanicsToUse: [[], null],
      elasticType: [null, null],
      elasticType2: [null, null],
      elasticType2Inferior: [null, null],
      elasticType2Superior: [ Class2TypeOptions.SuperiorPreMolarTrimming, null],
      elasticType3: [null, null],
      elasticType3Inferior: [Class3TypeOptions.CanineTrimming,, null],
      elasticType3Superior: [null, null],
      crossedElasticType: [null, null],
      crossedElasticTypeSuperior: [null, null],
      crossedElasticTypeInferior: [null, null],
      upperDistalizationType: [ManufacturingType.Group, null],
      lowerDistalizationType: [ManufacturingType.Group, null],
      upperMesializationType: [ManufacturingType.Group, null],
      lowerMesializationType: [ManufacturingType.Group, null],
      verticalOverbiteType: [VerticalOverbiteType.Keep, null],
      verticalOverbiteQuantity: [null, Validators.minLength(.1)],
      aditionalMechanicsValuesComments: ["", null]
    });

    if (this.isCaseDetail)
    {
      this.selectAllAditionalMechanicsToUseOptions();
    }

    this.stepFormGroup.valueChanges.subscribe((value) => {
      this.checkValidForm();
    });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public updateStepPrescription(): void
  {
    // Set prescriptionId in stepFormGroup
    this.stepFormGroup.controls['id'].setValue(this.GetPrescriptionId);

    this.prescriptionDataService.updatePrescriptionStep(this.GetSetupId, this.prescriptionNumber, this.stepFormGroup.value)
      .subscribe((response) =>
      {
        let body = 
        {
          id: this.GetSetupId,
          currentStep: 10
        }
        this.updateSetupCurrentStep(body);
        this.setSuccessAlert('Paso guardado correctamente');
      }, fail =>
      {
        this.setWarningAlert('Hubo un error al actualizar la prescripción: '+ fail.error.message);
      });
  }

  public onCheckboxChange(checked:boolean, value: AditionalMechanicsType): void
  {
    this.aditionalMechanicsTypeOptions.find(x => x.value == value).checked = checked;
    if(this.aditionalMechanicsTypeOptions.find(x => x.value == value && value == AditionalMechanicsType.ElasticsType2))
    {
      this.stepFormGroup?.controls['elasticType2Superior'].setValue(Class2TypeOptions.SuperiorCanineTrimming);
    }

    if(this.aditionalMechanicsTypeOptions.find(x => x.value == value && value == AditionalMechanicsType.ElasticsType3))
    {
      this.stepFormGroup?.controls['elasticType3Inferior'].setValue(Class3TypeOptions.CanineTrimming);
    }
    
    this.stepFormGroup.controls['aditionalMechanics'].setValue(this.result);
    if (this.stepFormGroup.controls['aditionalMechanics'].value.length == 0)
      {
        this.formAditionalMechanicsHasError = true;
        
      }
      else{
        this.formAditionalMechanicsHasError = false;
      }
      this.checkValidForm();
  }

  public onCheckboxMechanicsToUseChange(checked:boolean, value: AditionalMechanicsToUse): void
  {
    this.aditionalMechanicsToUseOptions.find(x => x.value == value).checked = checked;
    this.stepFormGroup.controls['aditionalMechanicsToUse'].setValue(this.result2);
    if (this.stepFormGroup.controls['aditionalMechanicsToUse'].value.length == 0)
    {
      this.formAditionalMechanicsToUseHasError = true;
      
    }
    else{
      this.formAditionalMechanicsToUseHasError = false;
    }
    this.checkValidForm();
  }

  public get result(): string[]
  {
    return this.aditionalMechanicsTypeOptions.filter(x => x.checked == true).map((x) => `${x.value}`);
  }

  public get result2(): string[]
  {
    return this.aditionalMechanicsToUseOptions.filter(x => x.checked == true).map((x) => `${x.value}`);
  }

  public selectAllAditionalMechanicsToUseOptions()
  {
    if(this.stepFormGroup.controls['aditionalMechanicsToUse'].value.contains("-1") || this.isCaseDetail)
    {
        this.aditionalMechanicsToUseOptions.forEach(x => x.checked=true);
        this.stepFormGroup.controls['aditionalMechanicsToUse'].setValue(["0","1","2","3","4","5"]); 
    }
    
  }

  public onCheckManufacturingType(itemName: string): boolean
  {
    return itemName.toLowerCase().includes('superior') || itemName.toLowerCase().includes('inferior');
  }

  public onCheckCrossedElasticsType(itemType: any): boolean
  {
    return itemType == AditionalMechanicsType.CrossedElastics;
  }

  public resetFormControlsStep6(stepFormGroup:any, controlName:any)
  {
    if (controlName == this.aditionalMechanicsTypeOptions.find(x => x.value == AditionalMechanicsType.ElasticsType2).controlName)
    {
        this.resetFormControl(stepFormGroup,controlName+"Inferior");
        this.resetFormControl(stepFormGroup,controlName+"Superior",0);
    }
    else if (controlName == this.aditionalMechanicsTypeOptions.find(x => x.value == AditionalMechanicsType.ElasticsType3).controlName) {
      this.resetFormControl(stepFormGroup, controlName + "Inferior",0);
      this.resetFormControl(stepFormGroup, controlName + "Superior");
    }
    else
    {
      this.resetFormControl(stepFormGroup,controlName);
    }
    
  }

  public checkValidForm()
  {
    if (this.stepFormGroup) {
      if (((this.stepFormGroup?.controls['verticalOverbiteQuantity'].valid && this.stepFormGroup?.controls['verticalOverbiteQuantity'].value!=null)
        ||this.stepFormGroup?.controls['verticalOverbiteType'].value != VerticalOverbiteType.ConcludeIn)
      ) {
        BroadcastManager.Instance.broadcast("step6Valid", true);
      }
      else {
        BroadcastManager.Instance.broadcast("step6Valid", false);
      }
    }
  }

  public isSkeletalAnchorChecked(): boolean
  {
    return this.aditionalMechanicsToUseOptions.find(x => x.value == AditionalMechanicsToUse.SkeletalAnchor).checked;
  }

  public disabledButtonStages():boolean
  {
    if(!this.formStep6Valid)
    {
      return true;
    }
    return false;
  }

  private updateSetupCurrentStep(body: any)
  {

    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {
      this.setCurrentSetupStep(body.currentStep);
    });
  }


}
